import useAjaxRequest from './useAjaxRequest';
import { URL_ADDRESS_QUERY } from '../config/endpoints';

const useAddressQuery = () => {
  const {
    response: { error, loading, data: address },
    performRequest,
  } = useAjaxRequest('addressQuery', {
    shouldCache: true,
    isCacheValid: ({ metadata }, { url }) => metadata.url === url,
  });

  const getAddress = cep =>
    performRequest({ method: 'get', url: URL_ADDRESS_QUERY(cep) });

  return { error, loading, address, getAddress };
};

export default useAddressQuery;
